/**
 * Define a command function inline.
 * @param fn Command function.
 */
export const command = (fn) => (props) => fn(props);
